import { LayoutGamesMainWebView } from "@/components/webview/games/layout/LayoutGamesMainWebView";
import GamesBannerWebView from "@/components/webview/games/core/GamesBannerWebView";
import { Button } from "@/v2-components/ui/button";
import { Button2 } from "@/components/webview/games/typograpy/typograpy-webview";
import React from "react";
import { useTrans } from "@/utils/useTrans";
import { GamesWrapLazyContentsWebView } from "@/components/webview/games/GamesWrapLazyContentsWebView";
import PsVr2LazySectionsWebView from "@/components/webview/games/main/PsVr2LazySectionsWebView";
import { openBrowserWebView } from "@/components/webview/utils/webViewBridge";

export const PsVr2WebView = () => {
  const { t } = useTrans(["games"]);

  return (
    <LayoutGamesMainWebView
      bannerImg={"/images/games/banners/ps-vr2-mobile@3x.jpg"}
      bannerContents={
        <>
          <GamesBannerWebView.Title text={t(`Effortless PSVR2 Setup`)} />
          <GamesBannerWebView.Description
            text={t(
              `Easily Connect PSVR2 content and TactSuit using the bHaptics Player App. Start the perfect VR experience with one button. Haptics Player App`,
            )}
          />
          <div className="mt-6 flex w-full flex-col gap-2 laptop:mt-8 laptop:flex-row">
            <Button
              size="sm"
              variant="darkgray-outline"
              shape="pill"
              className="bg-transparent px-6 laptop:text-blue-60 laptop:outline-blue-60 laptop:hover:bg-blue-60 laptop:hover:text-white"
              onClick={() => {
                openBrowserWebView({
                  url: "support/help/?categorySlug=iosgetting-start",
                });
              }}
            >
              <Button2>{t("Getting Started", { ns: "gnb" })}</Button2>
            </Button>
            <Button
              size="sm"
              variant="darkgray-fill"
              shape="pill"
              className="bg-black px-6 text-white focus-visible:outline-none"
              onClick={() => {
                openBrowserWebView({
                  url: "games/vr/software/",
                });
              }}
            >
              <Button2>{t("bHaptics Player for PC")}</Button2>
            </Button>
          </div>
        </>
      }
    >
      {/* lazy 하게 게임컴포넌트를 가져옵니다 */}
      <GamesWrapLazyContentsWebView contents={<PsVr2LazySectionsWebView />} />
    </LayoutGamesMainWebView>
  );
};
